import Request from '@/plugins/request';

export function getFundSettlefkLogs(params) {
  return Request.get('fund-settlefk-logs', { params })
}

export function createFundSettlefkLog() {
  return Request.get(`fund-settlefk-logs/create`)
}

export function storeFundSettlefkLog(data) {
  return Request.post('fund-settlefk-logs', data)
}

export function updateFundSettlefkLog(id, data) {
  return Request.put(`fund-settlefk-logs/${id}`, data)
}

export function editFundSettlefkLog(id) {
  return Request.get(`fund-settlefk-logs/${id}/edit`)
}

export function destroyFundSettlefkLog(id) {
  return Request.delete(`fund-settlefk-logs/${id}`)
}

export function dateList() {
  return Request.get(`fund-settlefk-logs/date-list`)
}

export function exportBonusExcel(data) {
  return Request.post('fund-settlefk-logs/export', data)
}

// 分红模拟
export function settleLogFake(data) {
  return Request.post('fund-settlefk-logs/settle-log-fake', data)
}


// 分红模拟
export function settleLogProduce(id) {
  return Request.get(`fund-settlefk-logs/settle-log-produce/${id}`)
}

